export const navigationSlidedownMixins = {
  props: {
    index: {
      type: Number,
      required: true,
    },
    activeMobileGroup: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isActive() {
      return this.activeMobileGroup === this.index;
    },
  },
  methods: {
    toggleMobileGroup() {
      this.$emit("toggle-group", this.isActive ? -1 : this.index);
    },
  },
};
